module.exports = __webpack_public_path__ + "static/media/trash.dc775daa.svg";